import * as React from "react";
import { useStore, useSelector, useDispatch } from "react-redux";
import "../assets/vendors/style";
import ds from "../Services/DataServices";
import { Form, Input, Button, Spin } from "antd";
import "../appRedux/actions/Auth";
import {
  userSignIn,
  checkIfTokenExpired,
} from "../appRedux/actions/Auth";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Password from "antd/lib/input/Password";
import Spinner from "reactstrap/lib/Spinner";
import { loadLoginLoader } from "../appRedux/actions/CommonData";
import { USER_STORE_FIND } from "../constants/ActionTypes";
import { useCookies } from "react-cookie";
import { env } from "../env";
import { isEmailValid } from "../appRedux/actions";
import { ShopOutlined } from "@ant-design/icons";
import BuzzTillBannerLogo from "../assets/images/buzztill_logo_text_only.png"
// import { REACT_APP_BUS_NAME, REACT_APP_BUS_SITE_APP } from "../constants/StoreSetting";
import ForgetPassModal from "./ForgetPassModal";
import { postDataToApp } from "../appRedux/actions/MobAppFn";
import { PostAppTypes } from "../constants/MobAppConstants";

const {REACT_APP_BUS_NAME, REACT_APP_BUS_SITE_APP} = env

const LogInStoreForm = () => {
  const baseURL = `${REACT_APP_BUS_SITE_APP}/signin`;
  const { TS_COOKIE_BASE_DOMAIN } = env;
  const store = useStore();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const history = useHistory();
  const [getIsLoading, setIsLoading] = React.useState(false);
  const [cookies, setCookie, removeCookie] = useCookies([
    "storeName",
    "storeHash",
    "reqNo"
  ]);

  interface loaderStateInterface {
    commonConfigs: any;
  }
  const loaderRedux = (state: loaderStateInterface) => state.commonConfigs;
  const loaderSelector = useSelector(loaderRedux);
  // const getReduxLoginLoader = useSelector(
  //   ({ commonConfigs }) => commonConfigs.getLoginLoader
  // );
  // const storess = useSelector((store: CommonDataSettings) => { return {students: store.manager.students} });
  // const profile = useSelector(state => state.profile);
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  interface authStateInterface {
    auth: any;
  }
  const authRedux = (state: authStateInterface) => state.auth;
  const authSelector = useSelector(authRedux);

  let query = useQuery();
  // const storeName = query.get("signupStore");
  // let storeName = localStorage.getItem("storeName");
  // let storeHash = localStorage.getItem("storeHash");
  let storeName = cookies.storeName;
  let storeHash = cookies.storeHash;
  let reqNo = cookies.reqNo;
  //let storeDataHash = localStorage.getItem("storeDataHash");
  let storeJson = { storeName: storeName, isReferer: false };

  const [loader, setloader] = React.useState();
  const [refererValue, setrefererValue] = React.useState(false);
  const [openForget, setOpenForget] = React.useState(false);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (
        storeName != null &&
        storeName != "" &&
        storeName != undefined &&
        storeName.length > 0 &&
        storeHash != null &&
        storeHash != "" &&
        storeHash != undefined &&
        storeHash.length > 0
      ) {
        localStorage.setItem("storeName", storeName);
        localStorage.setItem("storeHash", storeHash);
        localStorage.setItem("storeReqNo", reqNo);
      }
      // if (storeName == null || storeName == '') {
      //   storeName = query.get("signupStore");
      //   if (storeName != null && storeName != '')
      //     localStorage.setItem("storeName", storeName);
      // }

      // if (storeHash == null || storeHash == '') {
      //   storeHash = query.get("storeToken");
      //   if (storeHash != null && storeHash != '')
      //     localStorage.setItem("storeHash", storeHash);
      // }
      // if (storeDataHash == null || storeDataHash == '') {
      //   storeDataHash = query.get("storeKey");
      //   if (storeDataHash != null && storeDataHash != '')
      //     localStorage.setItem("storeDataHash", storeDataHash);
      // }

      // || storeDataHash == null || storeDataHash == ""
      if (
        storeName == null ||
        storeName == "" ||
        storeHash == null ||
        storeHash == ""
      ) {
        if (
          window.location &&
          window.location.host &&
          !window.location.host.includes("localhost") &&
          !window.location.host.includes("192")
        ) {
          window.location.href = baseURL;
        } else {
          history.push("/signin");
        }
      }
      checkIfTokenExpired(dispatch, history);
      
      if (authSelector.authdVariable.value == true) {
        if (authSelector.authdVariable.token != "") {
          history.push("/Dashboard");
        }
      }
    }
    return () => {
      mounted = false;
    };
  }, []); // authSelector.authdVariable.value

  // useEffect(() => {
  //   const asd = authSelector;
  //   if (loaderSelector && loaderSelector.getLoginLoader == true) {
  //     setIsLoading(true);
  //   } else {
  //     setIsLoading(false);
  //   }
  // }, [loaderSelector.commonConfigs]);

  //const storeHash=localStorage.getItem("storeHash");
  let currentValue1 = store.getState().auth;

  const submitValues = {
    userName: "",
    userPassword: "",
    storeName: "",
  };
  //storeDataHash: ""

  const doSubmit = async (value: any) => {
    // setIsLoading(true);
    dispatch(loadLoginLoader(true));
    // submitValues.storeDataHash = storeDataHash != null ? storeDataHash : "";
    submitValues.storeName = storeName != null ? storeName : "";
    submitValues.userName = value.userName
      ? value.userName.trim().toLowerCase()
      : "";
    submitValues.userPassword = value.userPassword;
    await dispatch(userSignIn(submitValues));
  };
  const notYourStore = () => {
    dispatch({
      type: USER_STORE_FIND,
      payload: {},
    });
    localStorage.clear();
    removeCookie("storeName", { domain: TS_COOKIE_BASE_DOMAIN });
    removeCookie("storeHash", { domain: TS_COOKIE_BASE_DOMAIN });
    removeCookie("reqNo", { domain: TS_COOKIE_BASE_DOMAIN });
    if (
      window.location &&
      window.location.host &&
      !window.location.host.includes("localhost")
    ) {
      window.location.href = baseURL + "?findStore=1";
    } else {
      history.push("/signin?findStore=1");
    }

    // history.push("/signin?findStore=1");
  };
  const FormItem = Form.Item;

  function closeForgetModal(){
    setOpenForget(false)
  }
  
  return (
    <div className="signin-panel-form-wrapper">
      <ForgetPassModal open={openForget} setClose={closeForgetModal} email={form.getFieldValue('userName')} />
      <Spin
        tip={"Loading"}
        spinning={loaderSelector && loaderSelector.getLoginLoader}
        size="large"
      >
        <Form
          form={form}
          initialValues={{ remember: true }}
          name="basic"
          //onSubmit={}
          onFinish={doSubmit}
          // onFinishFailed={onFinishFailed}
          className=""
        >
          <div className="cv-signin-header">
            {/* <img
              alt=""
              className="cv-signin-header-image"
              src="https://www.dakarsoftware.com/wp-content/uploads/2019/11/dakar-logo-150.png"
              height="57"
            /> */}
             <img  className="cv-signin-header-image"  height="57" alt="" src={BuzzTillBannerLogo}/> 
            <h1 className="cv-signin-header-text">Sign in</h1>
          </div>

          <div className="ant-row ant-form-item">
            <div className="ant-col ant-form-item-control">
              
            <div className="d-flex align-items-center">
            <div className="Store-Name shop-icon-add mr-auto"><ShopOutlined /> {storeName}</div>
            <a onClick={notYourStore} className="primary-anchor"> Not your store? </a>
          </div>

            </div>
          </div>

          

          
            <FormItem
              name="userName"
              rules={[
                {
                  required: true,
                  message: "Please enter your email",
                },
                {
                  validator: isEmailValid,
                },
              ]}
            >
              <Input
                placeholder="Enter Email Address" />
            </FormItem>

        
            <FormItem
              name="userPassword"
              rules={[
                {
                  required: true,
                  message: "Please enter your password.",
                },
              ]}
            >
              <Input type={"password"} placeholder="Password" />
            </FormItem>

            <div className="ant-row ant-form-item">
            <div className="ant-col ant-form-item-control">

            <div className="d-flex d-flex-devices  align-items-center">
            <a className="primary-anchor mr-auto fp" onClick={()=> { setOpenForget(true) }}>Forget Password?</a>
            <Button className="btn-signin btn-reversed" type="primary" disabled={loader} htmlType="submit" loading={loader}>
              {"Sign In"}
            </Button>
          </div>

            
            </div>
            </div>

          <FormItem name="newSignup">
            <div className="custom-text-center cus-mt-20 cus-mt-0-md">
              <p className="mb-0">Don't have an account?{" "}  
               <a href="/SignUp" className="primary-anchor br-txt">Try {REACT_APP_BUS_NAME} for free</a>
              </p>
            </div>
            {}
          </FormItem>
        </Form>
      </Spin>
    </div>
  );
};
export default LogInStoreForm;
